import { render } from "./dashboard.vue?vue&type=template&id=03f95897&ts=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__